import React, { useState } from "react";
import { FaPlay } from "react-icons/fa";

const ReviewFloat = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Floating Review Button (LEFT SIDE) */}
      
<div
  onClick={() => setOpen(true)}
  className="fixed bottom-6 left-4 z-50 flex flex-col items-center cursor-pointer"
>
  {/* Gradient Ring */}
  <div className="p-[2px] rounded-full bg-gradient-to-tr from-pink-500 via-red-500 to-yellow-500">
    
    {/* Thumbnail Circle */}
    <div className="w-12 h-12 rounded-full overflow-hidden relative shadow-lg">
      
      <img
        src="https://res.cloudinary.com/drnzo7nhz/image/upload/v1773922089/IMG_20260319_173439_pfb4oc.jpg"
        alt="review"
        className="w-full h-full object-cover"
      />

      {/* Overlay + Play */}
      <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
        <FaPlay className="text-white" size={12} />
      </div>

    </div>

  </div>

  {/* Label */}
  <span className="text-[11px] text-white bg-black/70 px-2 py-[2px] rounded mt-1 backdrop-blur-sm">
    Reviews⭐ 
  </span>
</div>
      {/* Video Popup */}
      {open && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50">
          
          {/* Close Button */}
          <button
            onClick={() => setOpen(false)}
            className="absolute top-5 right-5 text-white text-2xl"
          >
            ✕
          </button>

          {/* Video Container */}
          <div className="w-[300px] h-[520px] rounded-xl overflow-hidden bg-black relative">

            <video
              src="https://res.cloudinary.com/drnzo7nhz/video/upload/q_auto:good,f_auto,vc_auto/v1773918668/lv_0_20260318165030_lwtlfw.mp4"
              autoPlay
              
              controls
              preload="metadata"
              playsInline
              className="w-full h-full object-cover"
            />

            

          </div>
        </div>
      )}
    </>
  );
};

export default ReviewFloat;